import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';
import { catchError, switchMap, finalize, filter, take } from 'rxjs/operators';
import { UiService } from '../services/ui/ui.service';
import { environment } from 'environments/environment';
@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  private isRefreshingToken!: boolean;
  private tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  constructor(
    private authenticationService: AuthService,
    private router: Router,
    private uiService: UiService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = currentUser && localStorage.getItem('tokenKey');
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('tokenKey')}`
        }
      });
    }
    return next.handle(request);
  }
}
